import { styled } from "theme/default/styled";

export const SRangeInputDelete = styled.button`
  margin-right: 20px;
`;
